import axios from 'axios'

const PipefyWrapper = {
  requestToPipefy: (accessToken, payload) => {
    return new Promise((resolve, reject) => {
      const url = 'https://api.pipefy.com/graphql'
      const headers = {
        'Content-Type': 'application/json',
        authorization: `Bearer ${accessToken}`
      }
      return axios.post(url, payload, { headers }).then(({ data }) => {
        if (data && data.errors && data.errors.length > 0) {
          data.message = data.errors.reduce((message, error, index) => {
            if (index > 0) return `${message}, ${error.message}`
            return error.message
          }, '')
          return reject(data)
        } else return resolve(data.data)
      }).catch(({ response: { data } }) => {
        return reject(data)
      })
    })
  },
  checkAccessToken: (accessToken) => {
    return new Promise((resolve, reject) => {
      const payload = {
        query: `{
          me {
            id
          }
        }`
      }
      return PipefyWrapper.requestToPipefy(accessToken, payload).then(({ me }) => {
        if (me && me.id) return resolve(true)
        return resolve(false)
      }).catch(err => {
        return reject(err)
      })
    })
  }
}

export default PipefyWrapper



// WEBPACK FOOTER //
// ./src/services/pipefy-wrapper.js